import { Modal } from "flowbite-react";
import { FormikProvider, getIn, useFormik } from "formik";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  changeStatusMaintenance,
  updateMaintenanceEndVisualRecords,
} from "../../../../common/services/maintenance.api";
import {
  IMaintenance,
  MAINTENANCE_STATUS,
} from "../../../../types/maintenance.type";
import { RegisterRow } from "../../../renters/components/forms/fields/RegisterRow";
import { getMaintenanceById } from "../../../../common/services/maintenance.api";
import FormAsaasPaymentMaintenance from "../forms/FormAsaasPaymentMaintenance";
import Loading from "../../../../common/components/ui/loading/Loading";
import TextareaFormik from "../../../renters/components/forms/TextareaFormik";
import * as Yup from "yup";
import { AuthContext } from "../../../../common/components/auth/authContext/AuthContext";
import { OverdueAlertModal } from "./OverdueWarningModal";
import ComboBoxFormik from "../../../../common/components/form/ComboBoxFormik";
import { useCompanyStore } from "../../../../common/states/store/Company";
import { getMechanics } from "@/common/services/employee.api";
import { IEmployee } from "@/types/employee.type";

type Props = {
  maintenance: { _id: string; licensePlate: string };
  onClose: () => void;
  data: IMaintenance;
};

const validationSchema = Yup.object().shape({
  registers: Yup.array().of(
    Yup.object().shape({
      type: Yup.string().required("O campo tipo é obrigatório"),
      content: Yup.string().test(
        "content-required",
        "O campo conteúdo é obrigatório para o Hodômetro",
        function (value) {
          const { type } = this.parent;
          if (type === "Odômetro") {
            return !!value;
          }
          return true;
        }
      ),
    })
  ),
});

export default function ModalFinalizeMaintenance(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [maintenanceData, setMaintenanceData] = useState<IMaintenance | null>(
    null
  );
  const [amountMaintenance, setAmountMaintenance] = useState(0);
  const [overdueWarningModal, setOverdueWarningModal] =
    useState<boolean>(false);
  const authCtx = useContext(AuthContext);
  const userEmail = authCtx.auth?.user?.email;
  const { filterMode, selectedCompanies } = useCompanyStore();

  const [mechanics, setMechanics] = useState<IEmployee[]>([]);
  const [hasItemsInBudget, setHasItemsInBudget] = useState<boolean>(false);

  useEffect(() => {
    if (!maintenanceData) return;

    let totalSellPrice = 0;
    maintenanceData.budgetMaintenance.corrective.map((item) => {
      if (maintenanceData.typePlanRenter === "Cliente Plus") {
        return;
      }

      const sellPrice = item.quantity * item.sellPrice;
      totalSellPrice += sellPrice;
    });

    maintenanceData.budgetMaintenance.misuse.map((item) => {
      const sellPrice = item.quantity * item.sellPrice;
      totalSellPrice += sellPrice;
    });

    const roundedTotalSellPrice = totalSellPrice.toFixed(2);
    setAmountMaintenance(parseFloat(roundedTotalSellPrice));
    // verifica em maintenandeData se meu budgetMaintenance tem itens em corrective ou misuse ou preventive
    setHasItemsInBudget(maintenanceData.budgetMaintenance.corrective.length > 0 ||
      maintenanceData.budgetMaintenance.misuse.length > 0 ||
      maintenanceData.budgetMaintenance.preventive.length > 0);

  }, [maintenanceData]);


  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      mechanic: "",
      maintenanceId: props.maintenance._id,
      licensePlate: props.maintenance.licensePlate,
      registers: [
        { type: "Frente do veículo", content: "" },
        { type: "Lateral direita do veículo", content: "" },
        { type: "Lateral esquerda do veículo", content: "" },
        { type: "Traseira do veículo", content: "" },
        { type: "Odômetro", content: "" },
        { type: "Foto de aérea da moto", content: "" },
      ],
      vehicle: {
        _id: props.data.vehicleId,
      },
      observations: [
        {
          text: "",
          date: "",
          author: "",
        },
      ],
      autoService: false,
    },
    onSubmit: async (data) => {
      data.observations.forEach((observations) => {
        if (!observations.author) {
          // Only set the author if it hasn't been set yet
          observations.author = userEmail || "";
        }
      });

      const activationData = {
        maintenanceId: data.maintenanceId,
        status: MAINTENANCE_STATUS.UNDER_REVIEW,
        updatedAt: new Date(),
        observations: data.observations,
        mechanic: data.mechanic,
        autoService: data.autoService || false,
      };


      const savePhotoDelivery = {
        _id: props.data._id,
        renterId: props.data.renterId,
        vehicleId: props.data.vehicleId,
        photosMaintenance: data.registers,
        nameRenter: props.data.name,
        licensePlate: props.data.licensePlate,
        endAt: new Date(),
      };

      const resultPhoto = await updateMaintenanceEndVisualRecords(
        savePhotoDelivery
      );
      if (!resultPhoto.ok) {
        notifyError(resultPhoto.message as string);
        return;
      }
      notifySuccess("Fotos salvas com sucesso");

      const result = await changeStatusMaintenance(activationData);

      if (!result.ok && result["hasPendingPayments"]) {
        setOverdueWarningModal(true);
        return;
      }

      if (!result.ok) {
        notifyError(result.message as string);
        return;
      }

      notifySuccess("Revisãos finalizada com sucesso!");
      props.onClose()
    },
  });

  const singleSelectedCompany = useMemo(() => {
    if (filterMode === "cities" && selectedCompanies.length === 1) {
      return selectedCompanies[0];
    }
    return null;
  }, [filterMode, selectedCompanies]);

  useEffect(() => {
    if (singleSelectedCompany) {
      getMechanics().then((result) => {
        if (result.ok) {
          setMechanics(result.data);
        }
      });
    } else {
      setMechanics([]);
    }
  }, [singleSelectedCompany]);

  useEffect(() => {
    async function loadMaintenanceData() {
      if (!props.data._id) {
        return;
      }

      const { data } = await getMaintenanceById(props.data._id);
      formik.setFieldValue("mechanic", data.mechanic);
      setMaintenanceData(data);
    }
    loadMaintenanceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data._id]);

  const registers = formik.values.registers;

  const observations = getIn(formik.values, "observations");
  const currentObservation = useMemo(() => {
    const total = observations.filter(({ date }) => !!date);
    return total.length;
  }, [observations]);

  const itensCharging = maintenanceData?.typePlanRenter.match(/Cliente Sem/gi)
    ? maintenanceData?.budgetMaintenance.corrective.concat(
      maintenanceData?.budgetMaintenance.misuse
    )
    : maintenanceData?.budgetMaintenance.misuse;


  return (
    <>
      <Modal
        className="relative dark:text-black "
        show={true}
        onClose={() => props.onClose()}
      >
        <form onSubmit={formik.handleSubmit}>
          <FormikProvider value={formik}>
            <Modal.Header className="dark:text-black">
              <h2 className="dark:text-black">
                Finalizar manutenção da moto: {props.maintenance.licensePlate}
              </h2>
            </Modal.Header>
            <Modal.Body
              className="w-full flex flex-wrap items-center justify-center border-gray"
              style={{
                minHeight: "calc(100vh - 300px)",
                height: "calc(100vh - 300px)",
              }}
            >
              <section>{/* Seção para informações adicionais sobre manutençao sem peças*/}
                {maintenanceData && !hasItemsInBudget && (
                  <div className="w-full bg-gray/40 rounded my-4 p-3">
                    <h2 className="font-semibold text-2xl mb-4">
                      Atenção!
                    </h2>
                    <p>
                      Esta manutenção não possui peças selecionadas no orçamento.
                      Selecione as peças para poder concluir a finalização!
                    </p>
                  </div>
                )}
              </section>
              <section className="grid grid-cols-1 my-4">
                {!maintenanceData && <Loading></Loading>}

                <div className="grid gap-2 py-4">
                  <h2 className="text-2xl font-semibold mb-4">
                    Fotos do Veículo
                  </h2>

                  {registers?.map((doc, index) => (
                    <div
                      key={index}
                      className={`space-x-3 px-3 py-2 my-0 rounded ${index % 2 ? "bg-gray/5" : "bg-gray/25"
                        }`}
                    >
                      <RegisterRow
                        initialData={doc || {}}
                        name={`registers.${index}`}
                        onRemoveClick={() =>
                          formik.setFieldValue(
                            "registers",
                            registers.filter((_, i) => i !== index)
                          )
                        }
                        prefix="end-maintenance"
                      />
                    </div>
                  ))}

                  <button
                    type="button"
                    className=" disabled:text-black/50"
                    onClick={() => {
                      formik.setFieldValue(`registers.${registers.length}`, {
                        type: "",
                        content: "",
                        verified: false,
                      });
                    }}
                  >
                    + campos para fotos
                  </button>
                </div>

                <section>
                  <div className="w-full dark:text-black bg-gray/40 rounded my-4 p-3">
                    <h2 className="font-semibold text-2xl mb-4">Observações</h2>
                    <div>
                      <TextareaFormik
                        label={`Observação`}
                        name={`observations.${currentObservation}.text`}
                        className="min-h-64 w-full rounded shadow-md focus:border-white"
                      />
                    </div>
                  </div>
                </section>

                <ComboBoxFormik
                  label="Selecione o mecânico responsável pela manutenção:"
                  name={"mechanic"}
                  options={[
                    { value: "", label: "-" },
                    ...mechanics.map((mechanic) => ({
                      value: mechanic.name as string,
                      label: mechanic.name,
                    })),
                  ]}
                  className="w-full"
                />

                <div className="flex items-center gap-2 mt-4 mb-4">
                  <input
                    type="checkbox"
                    id="autoService"
                    name="autoService"
                    checked={formik.values.autoService}
                    onChange={(e) =>
                      formik.setFieldValue("autoService", e.target.checked)
                    }
                    className="h-4 w-4 accent-red-600"
                  />
                  <label
                    htmlFor="autoService"
                    className="text-sm font-bold text-red-600"
                  >
                    Serviço realizado pelo próprio Locatário?
                  </label>
                </div>

                {itensCharging?.length && maintenanceData ? (
                  <FormAsaasPaymentMaintenance
                    itens={itensCharging}
                    amountMaintenance={amountMaintenance}
                    renter={{
                      _id: maintenanceData.renterId,
                      name: maintenanceData.name,
                    }}
                    maintenanceId={maintenanceData._id as string}
                    licensePlate={maintenanceData.licensePlate as string}
                    onFormSubmitSuccess={formik.handleSubmit}
                    dateDue={new Date()}
                    typePlanRenter={maintenanceData.typePlanRenter}
                  />
                ) : (
                  <div className="items-center justify-center text-center mt-4">
                    <h2 className="font-semibold ">
                      Clique aqui para finalizar a manutenção dessa moto:
                    </h2>
                    <div className="grid-div2">
                      <ButtonWithLoader
                        isLoading={formik.isSubmitting}
                        disabled={
                          !hasItemsInBudget ||
                          Object.keys(formik.errors).length > 0 ||
                          !formik.values.mechanic
                        }
                        onSave={formik.handleSubmit}
                      >
                        Finalizar
                      </ButtonWithLoader>
                    </div>
                  </div>
                )}
              </section>
            </Modal.Body>
          </FormikProvider>
        </form>
      </Modal >

      <OverdueAlertModal
        isOpen={overdueWarningModal}
        onClose={() => setOverdueWarningModal(false)}
      />
    </>
  );
}
